module.exports = __webpack_public_path__ + "assets/img/icon-badge-20454630.png";